import { hideSideMenu, isElectron } from "../../../libs/roomnew";
import { setSenderMaxFramerate } from "../tracks/functions";
import { updateVideoQuality } from "../video-quality/actions";
import { setCurrentMaxResolution } from "../video-quality/functions";
import { PERFORMANCE_ICON } from "./constants";
import { getPerformanceSetting, getPerformanceState, monitorFrameRate, showPerformanceOptimizerSettingsChangedTooltip, startCollectingCpuLoad, storePerformanceSetting, updatePerformanceSettingState } from "./functions";

export const showPerformanceMenuItem=()=>{

        const optionIcon = $('<div/>', {
            class: "option-icon",
            id: "performance-optimizer-icon",
            html: PERFORMANCE_ICON,
        });
        const optionName = $('<div/>', {
            class: "option-name",
            id: "option-name-vbg",
            html: `Performance Optimizer`,
        });
        const optionAction = $('<div/>', {
            class: "option-action",
            id: "option-action-vbg",
            html: '',
        });
        const optionDescription = $('<div/>', {
            class: "option-description",
            html: [ optionName, optionAction],
        });
        const optionsBtn = $('<div/>', {
            class: 'option',
            id: 'performanceOptimizerOption',
            html: [optionIcon, optionDescription],
        }).on('click',function(){
            showPerformanceOptimizerModal();
            hideSideMenu();
        });


        $("#option-list").find("#performanceOptimizerOption").remove();
        $("#option-list").append(optionsBtn);

}

export const showParticipantNumberItem = (participantsNumber) => {
    if ($("#participantCounter").length === 0) {
        const participantsCounter = $('<h6/>', {
            class: 'dropdown-footer px-2 py-3 mb-0 text-center',
            id: 'participantCounter',
            html: `# People in Kino: ${participantsNumber}`,
        });
        $(".options-body").append(participantsCounter);
    }
}


export const hidePerformanceMenuItem=()=>{
    $("#options-list").find("#performanceOptimizerOption").remove();
}


export const showPerformanceOptimizerModal=()=>{
    const {setting,remember}=getPerformanceState();
    $("#performanceOptimizer").val(setting);
    $('#performanceOptimizerCheckbox').prop({checked:remember});
    $("#performanceOptimizerModal").modal()
}

export const applyPerformanceSetting=(value,persistent,byUser=false)=>{

    const {setting}=getPerformanceState();
    updatePerformanceSettingState(value,persistent,byUser);
    if(persistent){
        storePerformanceSetting(value);
    }
    if(setting != value){
        console.log(`PERFORMANCE OPTIMIZER applying setting ${value}, persistent ${persistent}`)
        const frameHeight=value <= 2 ? value * 180 : 720;
        setCurrentMaxResolution(frameHeight);
        updateVideoQuality(false,true);
        const {maxFrameRate} = getPerformanceState();
        setSenderMaxFramerate(maxFrameRate)
        if(!byUser){
            const newSetting = value == 3 ? "Quality" : value == 2 ? "Balanced" : "Performance";
            showPerformanceOptimizerSettingsChangedTooltip(newSetting);
        }
        // setTimeout(()=>{
        //     console.log("PERFORMANCE OPTIMIZER recapture camera")
        //     // reCaptureCamera(dispatch,getState());
        // },200)
    }
}

export const loadPerformanceSettingFromStore=()=>{
    const setting = getPerformanceSetting();
    console.log("Loaded performance setting from store",setting)
    // if(isElectron){
    //     startCollectingCpuLoad();
    // }
    updatePerformanceSettingState(setting,setting < 3,setting < 3);
    applyConferencePerformanceSettings();
    monitorFrameRate();
    if(setting < 3){
        setTimeout(() => {
            $.showNotification({
                body: "Performance Optimizer settings applied",
                type: "white",
                duration: 6000
            });
        }, 2000);
    }
}

export const applyConferencePerformanceSettings=()=>{
    const {frameHeight}=getPerformanceState();
    setCurrentMaxResolution(frameHeight);
}

export const addPerformanceOptimizerEvents=()=>{
    $('#apply-performance-setting').on('click',()=>{
        const setting = parseInt($("#performanceOptimizer").val(),10);
        const remember = $('#performanceOptimizerCheckbox').is(':checked');
        applyPerformanceSetting(setting,remember,true)
    })
}
